module.exports = __webpack_public_path__ + "assets/img/12.c4cde506.jpg";